module.exports = __webpack_public_path__ + "static/media/close.dfca1b37.svg";